import { render, staticRenderFns } from "./Resellers.vue?vue&type=template&id=5b00d402&scoped=true&"
import script from "./Resellers.vue?vue&type=script&lang=js&"
export * from "./Resellers.vue?vue&type=script&lang=js&"
import style0 from "./Resellers.vue?vue&type=style&index=0&id=5b00d402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00d402",
  null
  
)

export default component.exports